import { Controller } from "@hotwired/stimulus"

const TYPE_DELAY_MS = 22
const HOLD_BEFORE_CYCLE_MS = 3200

export default class extends Controller {
  static targets = ["message"]
  static values = {
    canned: { type: Array, default: [] },
  }

  connect() {
    this.cancelled = false
    this.queue = this.buildQueue()
    this.runNext()
  }

  disconnect() {
    this.cancelled = true
    if (this.typeTimer) clearTimeout(this.typeTimer)
    if (this.holdTimer) clearTimeout(this.holdTimer)
  }

  buildQueue() {
    const seed = (this.messageTarget.textContent || "").trim()
    const canned = (this.cannedValue || []).filter(m => m && m !== seed)
    return [seed, ...canned].filter(Boolean)
  }

  runNext() {
    if (this.cancelled || this.queue.length === 0) return
    const next = this.queue.shift()
    this.queue.push(next)
    this.typeMessage(next, () => {
      this.holdTimer = setTimeout(() => this.runNext(), HOLD_BEFORE_CYCLE_MS)
    })
  }

  typeMessage(text, done) {
    this.messageTarget.textContent = ""
    let i = 0
    const tick = () => {
      if (this.cancelled) return
      this.messageTarget.textContent = text.slice(0, i)
      i += 1
      if (i <= text.length) {
        this.typeTimer = setTimeout(tick, TYPE_DELAY_MS)
      } else {
        done()
      }
    }
    tick()
  }
}
